const APP = {}

const DOCUMENT = $(document)
const WINDOW = $(window)
const BODY = $(document.body)
const MAIN = $('.main')

let WIN_WIDTH = WINDOW.width()
let WIN_HEIGHT = WINDOW.height()
let DOC_WIDTH = DOCUMENT.width()
let DOC_HEIGHT = DOCUMENT.height()

const CLASS = {
	_active: 'is-active',
	_current: 'is-current',
	_valid: 'is-valid',
	_error: 'is-error',
	_focus: 'is-focus',
	_filled: 'is-filled',
	_noscroll: 'is-noscroll',
	_move: 'is-move',
	_open: 'is-open',
	_show: 'is-show',
	_expand: 'is-expand',
	_animate: 'is-animate',
	_noscroll: 'is-noscroll',
	_sticky: 'is-sticky',
	_docked: 'is-docked',
	_played: 'is-played',
	_disabled: 'is-disabled',
	_loader: 'is-loader',
	_selected: 'is-selected',
	_blur: 'is-blur',
	_checked: 'is-checked',
	_scroll: 'is-scroll',
	_done: 'is-done',
}

let lang = new URL(location.href).pathname.split('/')[1]
if (lang === 'phat-trien-ben-vung-2023') {
	lang = new URL(location.href).pathname.split('/')[2]
}
const apiURL = 'https://heineken-vietnam.com.vn/phat-trien-ben-vung-2023/wp-api'

APP.isMobile = function () {
	if (navigator.userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i))
		return true
	else return false
}

APP.isTablet = function () {
	if (navigator.userAgent.match(/Tablet|iPad/i)) return true
	else return false
}

APP.isDesktop = function () {
	if (!APP.isMobile() && !APP.isTablet()) return true
	else return false
}

APP.isLandscape = function () {
	if (window.innerHeight < window.innerWidth) return true
	else return false
}

APP.resize = function (func, timer) {
	let resizeEnd
	timer = timer || 150
	window.addEventListener('resize', function () {
		clearTimeout(resizeEnd)
		resizeEnd = setTimeout(func, timer)
	})
	return true
}

APP.getResize = function () {
	WIN_WIDTH = WINDOW.width()
	WIN_HEIGHT = WINDOW.height()
	DOC_WIDTH = DOCUMENT.width()
	DOC_HEIGHT = DOCUMENT.height()
}

APP.setScrollTopAnimation = function (element, posY, callback) {
	gsap.to(element, {
		scrollTo: {
			y: posY,
			autoKill: false,
		},
		duration: 0.4,
		ease: 'power0',
		onComplete: function () {
			if (callback) {
				setTimeout(function () {
					callback()
				}, 150)
			}
		},
	})
	return true
}

APP.getScrollTop = function () {
	return window.scrollY
}

APP.setCookie = function (key, value, days) {
	const expires = new Date()
	expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
	document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString()
	return true
}

APP.getCookie = function (key) {
	const keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)')
	return keyValue ? keyValue[2] : null
}

APP.removeCookie = function (key) {
	APP.setCookie(key, '', -1)
	return true
}

APP.getParameterByName = function (query) {
	query = query.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
	var regex = new RegExp('[\\?&]' + query + '=([^&#]*)'),
		results = regex.exec(location.search)
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

APP.getScrollbarWidth = function () {
	const outer = document.createElement('div')
	outer.style.visibility = 'hidden'
	outer.style.overflow = 'scroll'
	outer.style.msOverflowStyle = 'scrollbar'
	document.body.appendChild(outer)
	const inner = document.createElement('div')
	outer.appendChild(inner)
	const scrollbarWidth = outer.offsetWidth - inner.offsetWidth
	outer.parentNode.removeChild(outer)
	return scrollbarWidth
}
